module.exports = __webpack_public_path__ + "static/img/cDR5.5c5efdbc.png";